export enum FormDataObjectType {
  ELEMENT = 'element',
  FILE = 'file',
}

export type MappedFormDataObject = {
  type: FormDataObjectType
  element: string
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  value: any | any[]
}

export type MutationVariables = {
  elements: MappedFormDataObject[]
  files: MappedFormDataObject[]
}
